import type mixpanel from 'mixpanel-browser';
import type { App } from 'vue';

type MixpanelClient = typeof mixpanel;

let mixpanelClient: MixpanelClient | null = null;
let mixpanelLoader: Promise<MixpanelClient> | null = null;

export function loadMixpanel(): Promise<MixpanelClient> {
  if (mixpanelClient) {
    return Promise.resolve(mixpanelClient);
  }

  if (!mixpanelLoader) {
    mixpanelLoader = import('mixpanel-browser').then(({ default: loadedMixpanel }) => {
      mixpanelClient = loadedMixpanel;
      return loadedMixpanel;
    });
  }

  return mixpanelLoader;
}

export const plugin = {
  install: function (app: App, options: { token: string; config?: Record<string, unknown> }): void {
    void loadMixpanel()
      .then((loadedMixpanel) => {
        loadedMixpanel.init(options.token, options.config);
        app.config.globalProperties.$mixpanel = loadedMixpanel;
      })
      .catch((error) => {
        console.warn('[mixpanel] Failed to initialize', error);
      });
  },
};

export default plugin;
